import script from "./PolicyTextComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicyTextComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PolicyTextComponent.vue?vue&type=style&index=0&id=e93a6c9a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e93a6c9a"]])

export default __exports__